<template>
    <div class="components-view">
        <main class="current-component">

            <vuescroll :ops="ops">
                <form ref="form" @submit.prevent="handleClickForm">
                    <div class="fields-group">
                        <field-wrapper type="text" v-model="fields[1].value" :options="{required: true, minLength: 5}" hint="Hint"></field-wrapper>
                    </div>
                    <div class="fields-group">
                        <field-wrapper v-model="fields[2].value" type="text" :options="{required: true, minLength: 3}" hint="Type some shit"></field-wrapper>
                    </div>
                    <input type="submit"/>
                </form>
                <form>
                <field-wrapper type="password" label="Password" :options="{required:true, minLength:8}"></field-wrapper>
                </form>
                <field-wrapper type="text" v-model="textN" label="Text notification"></field-wrapper>
                <field-wrapper type="number" v-model="timeN" label="Time notification"></field-wrapper>
                <field-wrapper type="select" v-model="typeN" label="Type notification" :options="{values: typesNotifications}"></field-wrapper>
                <div @click="pushNotification" class="sub-box"><a href @click.prevent class="btn">Push notification</a></div>
                <div style="display: flex">
                    <form class="form test-form">
                        <div class="fields-group">
                            <field-wrapper v-for="(field,index) in fields" :key="index"
                                           v-model="field.value"
                                           @input="handleInput"
                                           :type="field.type"
                                           :options="field.options"
                                           :label="field.label"
                                           :clone="field.clone"
                                           :hint="field.hint"
                                           :id="field.id"
                            ></field-wrapper>
                        </div>
                    </form>

            .        <div class="form test-form">
                        <div class="fields-group">
                        <div class="dashboard-item" v-for="(field,index) in fields" :key="index">
                            <field-wrapper-disabled
                                           :value="field.value" :options="field.options" :type="field.type"
                                           :label="field.label"
                                           :id="field.id"
                            ></field-wrapper-disabled>
                        </div></div>
                    </div>
                </div>

            </vuescroll>
        </main>
    </div>
</template>

<script>

    import DateField from "./common/fields/DateField";
    import vuescroll from 'vuescroll';
    import FieldWrapperDisabled from "./common/fields/FieldWrapperDisabled";
    import FieldWrapper from "./common/fieldsV2/FieldWrapper";
    import {NOTIFICATION_WARNING,NOTIFICATION_DANGER,NOTIFICATION_SUCCESS, NOTIFICATION_INFO} from "../constants/common";
    import SimpleInput from "./common/fieldsV2/SimpleInput";
    import InputField from "./common/fieldsV2/InputField";
    import FieldGroup from "./common/fields/FieldsGroup";
    import FormComponent from "./common/fieldsV2/FormComponent";


    export default {
        name: 'documents-component-box',
        components: {
            FormComponent,
            FieldGroup,
            InputField,
            SimpleInput,
            FieldWrapperDisabled,
            FieldWrapper,
            vuescroll
        },
        data() {
            return {
                show: 0,
                ops: {
                    vuescroll: {
                        pullRefresh: {
                            enable: true
                        },
                        pushLoad: {
                            enable: true,
                            auto: true,
                            autoLoadDistance: 10
                        }
                    },
                },
                typesNotifications: [
                    NOTIFICATION_DANGER,
                    NOTIFICATION_SUCCESS,
                    NOTIFICATION_INFO,
                    NOTIFICATION_WARNING
                ],
                typeN: 'info',
                textN: 'Ahtung!!! Ahtung!!1!',
                timeN: 3000,
                component: DateField,
                msg: 'Документы',
                fields: [
                    {
                        id: 1,
                        label: "Имя*",
                        type: 'text',
                        options: {
                            required: true,
                            minLength: 5,
                        },
                        //clone: true,
                        value: 'True d',
                        hint: "Name"
                    },
                    {
                        id: 2,
                        label: "Пароль",
                        type: 'password',
                        options: {
                            required: true
                        },
                        value: "123",
                        clone: true,
                    },
                    {
                        id: 3,
                        label: "Число",
                        type: 'text',
                        options: {

                        },
                        clone: true,
                        value: ''
                    },
                    {
                        id: 4,
                        label: "Дата",
                        type: 'date',
                        options: {

                        },
                        value: '',
                        clone: true,
                    },
                    {
                        id: 554,
                        label: "Дата",
                        type: 'date',
                        options: {

                        },
                        value: '',
                        clone: true,
                    },
                    {
                        id: 7,
                        label: "Статус",
                        value: "",
                        type: 'select',
                        options: {
                            values:
                                ["Директор", "Менеджер", "Маркетолог", "Дизайнер"]
                        },
                        clone: true
                    },
                    {
                        id: 8,
                        label: 'Textarea',
                        type: 'textarea',
                        options: {
                            rows: 3
                        },
                        value: '',
                        clone: true

                    },
                    {
                        id: 9,
                        //label: 'File',
                        type: 'file',
                        options: {
                        },
                        //clone: true,
                        value: []
                    },
                    {
                        id: 11545,
                        //label: "Radio list",
                        //clone: true,
                        type: 'radio-list',
                        options:{
                            values: [
                                "<strong>Я эксперт</strong>. Давно занимаюсь саморазвитием, прошёл много тренингов, прочитал много книг.\n                Достиг значительных результатов.",
                                "<strong>Я продвинутый</strong>. Читал книги, проходил тренинги личностного роста. Самостоятельная работа удаётся плохо.",
                                "<strong>Я\n                        начинающий</strong>. В основном мои знания – из книг. Тренингов не проходил, самостоятельно с\n                        собой не работал.",
                                "<strong>Я\n                        Новичок</strong>. Не читал книг, не проходил тренингов личностного роста, не занимался\n                        саморазвитием."
                            ]}
                    },
                   /* {
                        id: 943,
                        label: 'Группа полей',
                        type: 'group',
                        clone: true,
                        options: {
                            fields: [
                                /!*{
                                    id: 6346,
                                    type: 'date',
                                    options: {
                                        width: 20
                                    },
                                    //clone: true,
                                },*!/
                                {
                                    id: 6346,
                                    type: 'text',
                                    options: {
                                        width: 50
                                    },
                                    //clone: true,
                                },
                                /!*{
                                    id: 6345236,
                                    type: 'text',
                                    options: {
                                        width: 50
                                    },
                                    //clone: true,
                                },*!/
                                {
                                    id: 435,
                                    label: "Another Group",
                                    type: 'group',
                                    //clone: true,
                                    options: {
                                        fields: [
                                            {
                                                id: 43335,
                                                type: 'text',
                                                options: {

                                                },
                                                //clone: true,
                                            },
                                            {
                                                id: 6341246,
                                                label: "Число",
                                                type: 'number',
                                                options: {

                                                },
                                                //clone: true,
                                            },
                                        ]
                                    },
                                    //clone: true,
                                },
                            ]
                        },
                        value:
                            {
                                values: [
                                    'dasdsdsad',
                                    /!*
                                        {
                                        values: [
                                            45,66
                                        ]
                                    }*!/

                                ]
                            }
                        /!*{
                            values: [
                                10,
                                20,
                                40,
                                { values: [
                                        50,60
                                    ]
                                },
                            ]
                        }*!/
                    },*/
                ],

            }
        },
        methods: {
            handleInput() {
                //this.answers[0][0].value = e
               // console.log(this.fields)
            },
            pushNotification() {
                this.$store.dispatch('pushNotification', {text: this.textN, type: this.typeN, time: Number(this.timeN)})
            },
            handleClickForm() {
                if (!this.$refs.form.checkValidity()) {
                    this.$refs.form.reportValidity();
                    console.log('error');
                } else {
                    console.log('ok');
                }
            }
        },

    }
</script>


<style scoped>
    .documents-component-box {
        padding: 20px;
    }
    .test-form {
        width: 50%;
    }

</style>
